import { Datatype } from '../../../../datatype/Datatype.ts';
import { createConditionOperator } from '../../IConditionOperator.ts';

const regexCache = new Map<string, RegExp>();

export const ConditionOperatorStringMatchesRegexType = createConditionOperator({
  code: 'stringMatchesRegex',
  label: "rispetta l'espressione regolare",
  description: 'Corrisponde al pattern di espressione regolare',
  args: [
    {
      type: 'staticValue',
      field: {
        type: Datatype.String,
        label: 'Es. ^[a-z]+$',
      },
    },
  ] as const,
  allowsField: field => field.type === Datatype.String,
  compare(value: any, [pattern]: any[]) {
    if (typeof pattern !== 'string' || pattern == null) return false;

    let regex = regexCache.get(pattern);
    if (regex == null) {
      regex = new RegExp(pattern);
      regexCache.set(pattern, regex);
    }

    // Evitiamo di confrontare stringhe vuote
    if (value == null) return false;
    if (typeof value !== 'string' || value.trim() === '') return false;

    return regex.test(value);
  },
});
